export default __webpack_public_path__ + "static/media/IMG-20240729-WA0006.2d45056f.jpg";